import {
  IconAnalytics,
  IconBinocularsGray,
  IconChartBar,
  IconClockGray,
  IconCoil,
  IconLayers,
  IconLocation,
  IconMeter,
  IconRoute,
  IconRulerGray,
  IconSearch,
  IconShareGray,
  IconWarning,
} from '@assets/images/icon';
import { rtlsSystem } from '@assets/images/solution';
import video from '@src/assets/images/solution/logisticsAsset/video/rtlsVideo.mp4';

import subVideo1 from '@src/assets/images/solution/logisticsAsset/video/sub/rtlsVideo1.mp4';
import subVideo2 from '@src/assets/images/solution/logisticsAsset/video/sub/rtlsVideo2.mp4';
import subVideo3 from '@src/assets/images/solution/logisticsAsset/video/sub/rtlsVideo3.mp4';
import subVideo4 from '@src/assets/images/solution/logisticsAsset/video/sub/rtlsVideo4.mp4';

import image1 from '@src/assets/images/solution/logisticsAsset/img/1.avif';
import image2 from '@src/assets/images/solution/logisticsAsset/img/2.avif';
import image3 from '@src/assets/images/solution/logisticsAsset/img/3.avif';
import image4 from '@src/assets/images/solution/logisticsAsset/img/4.avif';

export default {
  type: 'Giải pháp logistics',
  banner: {
    title: 'Tự động ghi lại di chuyển tài sản kho, kiểm soát xuất nhập kho theo thời gian thực',
    desc: 'Tự động theo dõi thời gian xuất nhập và lộ trình di chuyển của tài sản, số hoá luồng logistics, kiểm soát tồn kho chính xác và phát hiện bất thường mà không cần thao tác thủ công.',
  },

  video: {
    title: 'Nâng cao hiệu quả vận hành kho với dữ liệu vị trí chính xác.',
    desc: 'Theo dõi vị trí từng tài sản trong kho phức tạp theo thời gian thực, tối đa hóa độ chính xác và hiệu quả quản lý tài sản.',
    play: video,
  },

  func: [
    {
      theme: 'Theo dõi và quản lý chính xác vị trí tài sản logistics.',
      title: 'Giám sát vị trí tài sản theo thời gian thực',
      desc: 'Ngay cả trong kho quy mô lớn, vị trí của từng tài sản vẫn được xác định chính xác trong phạm vi ±50cm, cho phép kiểm tra trạng thái và phân bố tài sản theo thời gian thực, hỗ trợ quản lý tồn kho nhanh chóng và chính xác.',
      sub1: 'Độ chính xác cao',
      icon1: IconRulerGray,
      sub2: 'Đồng bộ dữ liệu nhanh',
      icon2: IconShareGray,
      image: image1,
    },
    {
      title: 'Đơn giản hoá quản lý với thẻ dán siêu nhỏ',
      desc: 'Gắn thẻ dán siêu nhỏ lên tài sản để dễ dàng quản lý, áp dụng hệ thống theo dõi vị trí cho mọi loại kích cỡ và hình dạng tài sản.',
      sub1: 'Theo dõi vị trí theo thời gian thực',
      icon1: IconBinocularsGray,
      sub2: 'Độ chính xác cao',
      icon2: IconRulerGray,
      image: image2,
    },
    {
      title: 'Hệ thống chuyên dụng cho quản lý tài sản quy mô lớn',
      desc: 'Quản lý và giám sát đồng thời hơn 10.000 tài sản tồn kho theo thời gian thực, đảm bảo hiệu quả cao trong môi trường logistics quy mô lớn.',
      sub1: 'Đồng bộ dữ liệu nhanh',
      icon1: IconShareGray,
      sub2: 'Nắm bắt trạng thái theo thời gian thực',
      icon2: IconClockGray,
      image: image3,
    },
    {
      title: 'Tìm kiếm và định vị tài sản ngay lập tức',
      desc: 'Tính năng tìm kiếm mạnh mẽ giúp dễ dàng xác định nhanh vị trí tài sản cần thiết, tiết kiệm tối đa thời gian và công sức quản lý kho.',
      sub1: 'Đồng bộ dữ liệu nhanh',
      icon1: IconShareGray,
      sub2: 'Nắm bắt trạng thái theo thời gian thực',
      icon2: IconClockGray,
      video: subVideo3,
    },
    {
      theme: 'Tận dụng dữ liệu tài sản để nâng cao hiệu suất và phòng ngừa rủi ro.',
      title: 'Theo dõi trạng thái xuất nhập kho theo thời gian thực',
      desc: 'Giám sát toàn bộ trạng thái xuất nhập logistics theo thời gian thực, theo dõi chính xác luồng di chuyển, ngăn ngừa lỗi vận hành ngay từ đầu.',
      sub1: 'Đồng bộ dữ liệu nhanh',
      icon1: IconShareGray,
      sub2: 'Nắm bắt trạng thái theo thời gian thực',
      icon2: IconClockGray,
      video: subVideo4,
    },
    {
      title: 'Giám sát lượng tồn kho tối ưu theo kho',
      desc: 'Phân tích lượng tồn kho tối ưu cho từng kho theo thời gian thực, tối ưu hoá không gian lưu trữ, giải quyết vấn đề thiếu chỗ chứa từ sớm.',
      sub1: 'Đồng bộ dữ liệu nhanh',
      icon1: IconShareGray,
      sub2: 'Nắm bắt trạng thái theo thời gian thực',
      icon2: IconClockGray,
      image: image4,
    },
    {
      title: 'Cảnh báo ngăn chặn mang tài sản ra ngoài trái phép & thất thoát',
      desc: 'Khi tài sản bị mang ra ngoài trái phép hoặc di chuyển vượt quá thời gian cho phép, hệ thống sẽ gửi cảnh báo ngay lập tức để ngăn chặn rủi ro mất mát tài sản.',
      sub1: 'Đồng bộ dữ liệu nhanh',
      icon1: IconShareGray,
      sub2: 'Nắm bắt trạng thái theo thời gian thực',
      icon2: IconClockGray,
      video: subVideo1,
    },
    {
      title: 'Giám sát trạng thái tồn kho theo thời gian thực',
      desc: 'Dễ dàng kiểm tra trạng thái tồn kho toàn bộ và theo khu vực theo thời gian thực, hỗ trợ quản lý tồn kho chính xác và ra quyết định nhanh chóng.',
      sub1: 'Đồng bộ dữ liệu nhanh',
      icon1: IconShareGray,
      sub2: 'Nắm bắt trạng thái theo thời gian thực',
      icon2: IconClockGray,
      video: subVideo2,
    },
  ],

  subfunc: {
    title: 'Tóm tắt tính năng chính',
    desc: '',

    data: [
      {
        icon: IconLocation,
        title: 'Kiểm tra vị trí tài sản theo thời gian thực',
        desc: 'Xác định chính xác vị trí của tất cả tài sản trong kho theo thời gian thực.',
      },
      {
        icon: IconCoil,
        title: 'Cung cấp thẻ dán siêu nhỏ',
        desc: 'Thẻ nhỏ dễ gắn lên nhiều loại tài sản để theo dõi vị trí.',
      },
      {
        icon: IconLayers,
        title: 'Quản lý đồng thời tài sản quy mô lớn',
        desc: 'Quản lý đồng thời hơn 10.000 tài sản theo thời gian thực.',
      },
      {
        icon: IconSearch,
        title: 'Tính năng tìm kiếm vị trí tài sản',
        desc: 'Tìm kiếm vị trí tài sản dễ dàng, nhanh chóng.',
      },
      {
        icon: IconRoute,
        title: 'Theo dõi xuất nhập kho theo thời gian thực',
        desc: 'Theo dõi chính xác trạng thái nhập kho và xuất kho theo thời gian thực.',
      },
      {
        icon: IconChartBar,
        title: 'Phân tích lượng tồn kho tối ưu theo kho',
        desc: 'Phân tích lượng tồn kho và không gian lưu trữ của từng kho, hỗ trợ vận hành hiệu quả.',
      },
      {
        icon: IconWarning,
        title: 'Cảnh báo tự động khi mang ra ngoài trái phép',
        desc: 'Cảnh báo ngay khi phát hiện tài sản bị mang ra ngoài trái phép hoặc di chuyển ngoài thời gian quy định.',
      },
      {
        icon: IconMeter,
        title: 'Kiểm tra trạng thái tồn kho theo thời gian thực',
        desc: 'Theo dõi trực quan tồn kho tổng thể và theo khu vực theo thời gian thực.',
      },
      {
        icon: IconRoute,
        title: 'Ghi lại lộ trình di chuyển tài sản',
        desc: 'Tự động ghi lại lộ trình di chuyển và lưu trữ dưới dạng dữ liệu.',
      },
      {
        icon: IconAnalytics,
        title: 'Báo cáo dữ liệu tài sản',
        desc: 'Phân tích dữ liệu di chuyển của tài sản và cung cấp báo cáo quản lý định kỳ.',
      },
    ],
  },

  system: {
    title: 'Cấu trúc hệ thống',
    img: rtlsSystem,
  },

  productTitle: 'Gói sản phẩm',
  product: [
    {
      tag: 'assetPackage',
    },
    {
      tag: 'workerPackage',
    },
  ],

  contents: [
    {
      data: 'logisticsSafety',
    },
    {
      data: 'constructionAsset',
    },
    {
      data: 'blogRTLS',
    },
    {
      data: 'blogForklift',
    },
  ],
};
